import { NgModule } from '@angular/core';
import { PromoCmsComponents } from '@core/const';
import { PromoDataAccessModule } from '@promo/data-access';
import { PromoFeatureModule } from '@promo/feature';
import { PromoModalLinkListenerService } from '@promo/ui';
import { CmsConfig, ConfigModule } from '@spartacus/core';

@NgModule({
  imports: [
    PromoFeatureModule,
    PromoDataAccessModule,
    ConfigModule.withConfig(<CmsConfig>{
      featureModules: {
        sdCatalogBanner: {
          module: () => import('./lazy/catalog-banner.module').then((m) => m.SdCatalogBannerModule),
          cmsComponents: [PromoCmsComponents.SdCMSCatalogBannerComponent],
        },
        sdSimpleBanner: {
          module: () => import('./lazy/simple-banner.module').then((m) => m.SdSimpleBannerModule),
          cmsComponents: [PromoCmsComponents.SimpleBannerComponent],
        },
        sdSimpleResponsiveBanner: {
          module: () => import('./lazy/simple-responsive-banner.module').then((m) => m.SdSimpleResponsiveBannerModule),
          cmsComponents: [PromoCmsComponents.SimpleResponsiveBannerComponent],
        },
        sdTimestampResponsiveBanner: {
          module: () =>
            import('./lazy/timestamp-responsive-banner.module').then((m) => m.SdTimestampResponsiveBannerModule),
          cmsComponents: [PromoCmsComponents.TimestampResponsiveBannerComponent],
        },
        sdTitledBanner: {
          module: () => import('./lazy/titled-banner.module').then((m) => m.SdTitledBannerModule),
          cmsComponents: [PromoCmsComponents.SdTitledBannerComponent],
        },
        sdSubstrateResponsiveBanner: {
          module: () =>
            import('./lazy/substrate-responsive-banner.module').then((m) => m.SdSubstrateResponsiveBannerModule),
          cmsComponents: [PromoCmsComponents.RosaCMSSubstrateResponsiveBannerComponent],
        },
        sdBannerCarouselTwoRows: {
          module: () => import('./lazy/banner-carousel.module').then((m) => m.SdBannerCarouselTwoRowsModule),
          cmsComponents: [PromoCmsComponents.RosaFormattedResponsiveBannerMultiLineCarouselComponent],
        },
        sdBannerCarouselPeek: {
          module: () => import('./lazy/banner-carousel.module').then((m) => m.SdBannerCarouselPeekModule),
          cmsComponents: [PromoCmsComponents.RosaFormattedResponsiveBannerOneLineCarouselComponent],
        },
        sdBannerCarousel: {
          module: () => import('./lazy/banner-carousel.module').then((m) => m.SdBannerCarouselModule),
          cmsComponents: [PromoCmsComponents.RotatingImagesComponent, PromoCmsComponents.RosaRotatingImagesComponent],
        },
        sdRandomBanner: {
          module: () => import('./lazy/random-banner.module').then((m) => m.SdRandomBannerModule),
          cmsComponents: [PromoCmsComponents.RandomBannerComponent],
        },
        sdFormattedResponsiveBanner: {
          module: () =>
            import('./lazy/formatted-responsive-banner.module').then((m) => m.SdFormattedResponsiveBannerModule),
          cmsComponents: [PromoCmsComponents.RosaFormattedResponsiveBannerComponent],
        },
      },
    }),
  ],
})
export class PromoShellEagerModule {
  constructor(promoModalLinkListenerService: PromoModalLinkListenerService) {
    void promoModalLinkListenerService;
  }
}
